export enum Prioridade {
  URGENTE = 'Urgente',
  IMPORTANTE = 'Importante',
  NORMAL = 'Normal'
}

export enum Status {
  PENDENTE = 'Pendente',
  CONCLUIDA = 'Concluída'
}
